import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ui-notice',
  imports: [NgClass],
  templateUrl: './notice.component.html',
  styleUrl: './notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoticeComponent {
  severity = input<string>('info');
  class = input<string>('');
}
